"use client";

import { MessageCircle } from "lucide-react";

import { getSupportHref, openSupportChat } from "@/lib/support-chat";

/**
 * The end of an expert docs page: somewhere to take the question the page did
 * not answer.
 *
 * Opens Sophia in place when she is on the page, so the page they were reading
 * stays in front of them and she is told which one it was. Otherwise it is a
 * link to the support page, carrying the page's title as an unsent draft, since
 * a signed-out reader has to sign in before she can answer and the support
 * page is where that happens.
 */
export function AskSophia({ pageTitle }: { pageTitle: string }) {
  const draft = `About the "${pageTitle}" page: `;
  return (
    <aside className="not-prose border-fd-border bg-fd-card mt-12 flex flex-col gap-4 rounded-xl border p-5 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <p className="text-fd-foreground font-medium">Still have a question?</p>
        <p className="text-fd-muted-foreground mt-1 text-sm">
          Ask Sophia, Terac&apos;s assistant. She knows these docs and can check
          your account.
        </p>
      </div>
      <a
        href={getSupportHref(draft)}
        onClick={(event) => {
          if (openSupportChat()) {
            event.preventDefault();
          }
        }}
        className="bg-marketing-blue inline-flex shrink-0 items-center justify-center gap-2 rounded-full px-4 py-2 text-sm font-medium text-white transition-opacity hover:opacity-90 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:outline-none"
      >
        <MessageCircle aria-hidden className="size-4" />
        Ask Sophia
      </a>
    </aside>
  );
}
